import Vue from "vue";
import Vuex from "vuex";
import routes from "@/router/menu";
import { mergeMenu, validateRoutes, allMenu } from "@/router/utils";

Vue.use(Vuex);

// @see https://github.com/PanJiaChen/vue-element-admin/blob/master/src/store/index.js
const modulesFiles = require.context("./modules", true, /\.js$/);

// you do not need `import app from './modules/app'`
// it will auto require all vuex module from modules file
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  // set './app.js' => 'app'
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, "$1");
  const value = modulesFiles(modulePath);
  modules[moduleName] = value.default;
  return modules;
}, {});

// const pagesFiles = require.context("./pages", true, /\.js$/);

// const pages = pagesFiles.keys().reduce((pages, pagePath) => {
//   // set './app.js' => 'app'
//   const pageName = pagePath.replace(/^\.\/(.*)\.\w+$/, "$1");
//   const value = pagesFiles(pagePath);
//   pages[pageName] = value.default;
//   console.log(pages);
//   return pages;
// }, {});

export default new Vuex.Store({
  // strict 嚴謹模式 (production 不要開啟，吃效能)
  // 不是由mutations所發起的更新，都會拋出Exception
  strict: process.env.NODE_ENV !== "production",
  state: {
    token: "",
    routes: [],
    toolDialogVisible: false,
    toolDialogTitle: "",
    fullscreenLoading: false
  },
  mutations: {
    updateToken(state, token) {
      state.token = token;
    },
    updateRoutes(state, routes) {
      state.routes = routes;
    },
    TOOL_DIALOG_STATUS(state, status = true) {
      state.toolDialogVisible = status;
    },
    TOOL_DIALOG_TITLE(state, title) {
      state.toolDialogTitle = title;
    },
    TOGGLE_FULL_SCREEN_LOADING(state, bool) {
      state.fullscreenLoading = bool;
    }
  },
  actions: {
    generateRoutes(context, payload) {
      const { user, menu } = payload;
      let routeMap = mergeMenu(routes, allMenu(menu), payload.i18n);
      const accessRoutes = validateRoutes(routeMap, user);
      context.commit("updateRoutes", accessRoutes);
    },
    showToolDialog(context, payload) {
      context.commit("TOOL_DIALOG_TITLE", payload.title);
      context.commit("TOOL_DIALOG_STATUS", true);
    },
  },
  modules,
  getters: {
    token: (state, getters) => {
      return getters["app/token"];
    },
    routes: (state) => {
      return state.routes;
    },
  },
});
